import type { ReactElement } from 'react';
import type { MCPServerListItem } from '@kirin/api-client/contracts/mcp';
import {
  MCPNameCell,
  MCPToolsCell,
  MCPTypeBadge,
  MCPTransportBadge,
  MCPVersionCell,
  MCPSourceBadges,
  MCPStatusIndicator,
} from '@/components/shared/mcp';
import { RelativeTimeWithTooltip } from '@/components/shared/RelativeTimeWithTooltip';
import { LastSeenFreshnessCell } from '@/components/shared/LastSeenFreshnessCell';

interface CellProps {
  row: MCPServerListItem;
}

export function NameCell({ row }: CellProps) {
  return (
    <MCPNameCell name={row.name} serverName={row.serverName} url={row.url} />
  );
}

export function ToolsCell({ row }: CellProps): ReactElement {
  return <MCPToolsCell serverName={row.name} tools={row.tools} />;
}

export function VersionCell({ row }: CellProps) {
  return <MCPVersionCell row={row} />;
}

export function PublisherCell({ row }: CellProps) {
  return (
    <span className="text-muted-foreground break-words whitespace-normal leading-snug">
      {row.publisher ?? '—'}
    </span>
  );
}

export function TypeCell({ row }: CellProps) {
  return <MCPTypeBadge type={row.type} />;
}

export function TransportCell({ row }: CellProps) {
  return <MCPTransportBadge transport={row.transport} />;
}

export function SourcesCell({ row }: CellProps) {
  return <MCPSourceBadges sources={row.sources} />;
}

export function StatusCell({ row }: CellProps) {
  return <MCPStatusIndicator runningCount={row.runningCount} />;
}

export function FirstSeenCell({ row }: CellProps) {
  return <RelativeTimeWithTooltip date={row.firstSeenAt} />;
}

export function LastSeenCell({ row }: CellProps): ReactElement {
  return <LastSeenFreshnessCell lastSeenAt={row.lastSeenAt} />;
}
